export var pluralize = function (count, noun, suffix) {
    if (suffix === void 0) { suffix = 's'; }
    return count + " " + noun + (count !== 1 ? suffix : '');
};
